import { render, staticRenderFns } from "./db_bak_page.vue?vue&type=template&id=6604c9df&scoped=true"
import script from "./db_bak_page.vue?vue&type=script&lang=js"
export * from "./db_bak_page.vue?vue&type=script&lang=js"
import style0 from "./db_bak_page.vue?vue&type=style&index=0&id=6604c9df&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6604c9df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6604c9df')) {
      api.createRecord('6604c9df', component.options)
    } else {
      api.reload('6604c9df', component.options)
    }
    module.hot.accept("./db_bak_page.vue?vue&type=template&id=6604c9df&scoped=true", function () {
      api.rerender('6604c9df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/record/db_bak_page.vue"
export default component.exports